import styled from 'styled-components'

export const TableRow = styled.tr`
	border-bottom: 1px solid var(--color-main-blue_green);
`
